/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-27 16:30:11
 * @LastEditTime: 2021-03-03 13:55:57
 * @LastEditors: cc
 */
/**
 * description：微博渠道-服务
 * author：Qian.qianchen 2018-11-19
 */
'use strict';
angular
    .module('editingCenterWeiBoServiceModule', [
        'weiboCreateModule',
        'weiboDirectSignModule',
        'weiboTimeSignModule',
        'weiboProcessRecordModule',
        'weiboWithdrawModule',
        'weiboRepostModule',
    ])
    .factory('editingCenterWeiBoService', [
        '$modal',
        '$q',
        'trsHttpService',
        'localStorageService',
        '$window',
        'editingCenterService',
        'weiboApiService',
        'weiboApiParams',
        '$state',
        function($modal, $q, trsHttpService, localStorageService, $window, editingCenterService, weiboApiService, weiboApiParams, $state) {
            $window.addEventListener('storage', function(e) {
                var draftInfo;
                try {
                    draftInfo = JSON.parse(localStorageService.get('unLockWeibo'));
                    // eslint-disable-next-line no-empty
                } catch (e) {
                } finally {
                    if (draftInfo && draftInfo.metadataid) {
                        localStorageService.remove('unLockWeibo');
                        unlockWeibo(draftInfo.metadataid).then(function(data) {});
                    }
                }
            });

            /**
             * [getDetailUrl 获取预览页]
             *
             * @param   {[type]}  doctypeID    [doctypeID description]
             * @param   {[type]}  mediatypeID  [mediatypeID description]
             *
             * @return  {[type]}               [return description]
             */
            function getDetailUrl() {
                let baseUrl = window.location.origin + '/xjmediaCloud/#/';
                let previewUrl = '';
                previewUrl += `wbpreview?wbmetadataid=${$state.params.wbmetadataid}&wbplatform=${$state.params.wbplatform}&wbchannelid=${$state.params.wbchannelid}`;
                return baseUrl + previewUrl;
            }

            /**
             * [getOprType 获取操作平台类型]
             *
             * @return  {[type]}  [return description]
             */
            function getOprType() {
                return {
                    '0': 'microblog.daibian',
                    '1': 'microblog.daishen',
                    '2': 'microblog.yiqianfa'
                }[$state.params.platform] || 'microblog.daibian';
            }

            return {

                /**
                 * [addFuture 为控制器作用域增加通用功能]
                 *
                 * @param   {[type]}  vm              [vm description]
                 * @param   {[type]}  methodNameList  [methodNameList description]
                 *
                 * @return  {[type]}                  [return description]
                 */
                addFuture: function (vm, methodNameList) {
                    for (var i = 0; i < methodNameList.length; i++) {
                        let methodName = methodNameList[i];
                        vm[methodName] = this[methodName];
                    }
                    return vm;
                },

                /**
                 * [sendmessage 发送消息到IM]
                 *
                 * @return  {[type]}  [return description]
                 */
                sendmessage: function () {
                    let that = this;
                    this.save(true).then((data) => {
                        const outerSourceId = that.list.METADATAID;
                        const title = that.list.CONTENT;
                        let articleDocType = editingCenterService.getDocTypeId();
                        let articleMediaType = editingCenterService.getEditPageMediaType();
                        let url = getDetailUrl();
                        const extraInfo = {
                            'articleDocType': articleDocType,
                            'articleMediaType': articleMediaType,
                            'articleUrl': url,
                            'metadataid': outerSourceId,
                            'isawaitrevise': !!$state.params.isawaitrevise,
                            'channelid': $state.params.wbchannelid,
                            'chnldocid': that.list.CHNLDOCID
                        };
                        const info = {
                            messageBody: {
                                content: '',
                                extraInfo: JSON.stringify(extraInfo),
                                messageType: 'ARTICLE_DOC', 
                                outerSourceId: outerSourceId,
                                platform: '',
                                title: title
                            },
                            outerSourceId: '',
                            oprType: getOprType(),
                            objId: $state.params.wbchannelid
                        };
                        editingCenterService.sendToStudio(info).then(function(result){
                            if (result.ISSUCCESS === 'true') {
                                setTimeout(() => {
                                    window.close();
                                }, 2000);
                            }
                        });
                    });
                },
                createWeibo: createWeibo, // 新建微博弹窗
                directSignWeibo: directSignWeibo, // 直接签发微博弹窗
                timeSignWeibo: timeSignWeibo, // 定时签发微博弹窗
                processRecord: processRecord, // 获取微博流程记录
                withdrawWeibo: withdrawWeibo, // 微博撤稿-撤稿原因填写弹窗
                repostWeibo: repostWeibo, // 微博转发
                isLock: isLock, // 判断该微博是否上锁
                lockWeibo: lockWeibo, // 微博上锁
                unlockWeibo: unlockWeibo, // 微博解锁
                forceUnlockWeibo: forceUnlockWeibo, // 微博强制解锁
                hasSensitiveWords: hasSensitiveWords, // 判断数组中含有敏感词的微博稿件
                initWeiboData: initWeiboData, // 初始化微博数据
                uploadVideo: uploadVideo, // 媒资选择器上传视频
                uploadPic: uploadPic, // 媒资选择器上传图片
                trail: trail, // 微博送审
                addAddress: addAddress, // 添加地点
                hasIllegalDoc: hasIllegalDoc // 是否有不合法稿件
            };

            
            /**
             * [hasIllegalDoc description] 是否有不合法稿件
             * @param  {[type]}  arr [description] 稿件列表
             * @return {Boolean}     [description]
             */
            function hasIllegalDoc(arr) {
                return arr.some((item) => {
                    if (item.PICTURE) {
                        return item.CONTENT.length > 5000 && item.PICTURE && item.PICTURE.length > 0;
                    }
                    return false;
                });
            }

            /**
             * [createWeibo 新建微博弹窗]
             *
             * @param   {[type]}  item        [item description]
             * @param   {[type]}  flowStatus  [flowStatus description]
             * @param   {[type]}  success     [success 成功后的回调函数]
             *
             * @return  {[type]}              [return description]
             */
            function createWeibo(item, flowStatus, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weibo/service/createWeibo/createWeibo_tpl.html',
                    windowClass: 'create-weibo',
                    backdrop: false,
                    keyboard: false,
                    controller: 'weiboCreateCtrl',
                    resolve: {
                        item: function() {
                            return item;
                        },
                        flowStatus: function() {
                            return flowStatus;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            }

            /**
             * [directSignWeibo 微博直接签发-填写审核意见弹窗]
             *
             * @param   {[type]}  itemArr     [itemArr 设置的微博对象数组]
             * @param   {[type]}  isSave      [isSave 是否保存]
             * @param   {[type]}  flowStatus  [flowStatus 流程状态]
             * @param   {[type]}  success     [success 成功后的回调函数]
             * @param   {[type]}  error     [error 失败后的回调函数]
             *
             * @return  {[type]}              [return description]
             */
            function directSignWeibo(itemArr, isSave, flowStatus, success, error) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weibo/service/directSign/directSign_tpl.html',
                    windowClass: 'direct-sign-weibo',
                    backdrop: false,
                    controller: 'weiboDirectSignCtrl',
                    resolve: {
                        itemArr: function() {
                            return itemArr;
                        },
                        flowStatus: function() {
                            return flowStatus;
                        },
                        isSave: function() {
                            return isSave;
                        },
                    },
                });
                modalInstance.result.then(
                    function(result) {
                        success(result);
                    },
                    function() {
                        error();
                    }
                );
            }

            /**
             * [timeSignWeibo 微博定时签发-设置签发时间弹窗]
             *
             * @param   {[type]}  itemArr     [itemArr 设置的微博对象数组]
             * @param   {[type]}  isSave      [isSave 是否保存]
             * @param   {[type]}  flowStatus  [flowStatus 流程状态]
             * @param   {[type]}  success     [success 成功后的回调函数]
             *
             * @return  {[type]}              [return description]
             */
            function timeSignWeibo(itemArr, isSave, flowStatus, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weibo/service/timeSign/timeSign_tpl.html',
                    windowClass: 'time-sign-weibo',
                    backdrop: false,
                    controller: 'weiboTimeSignCtrl',
                    resolve: {
                        itemArr: function() {
                            return itemArr;
                        },
                        flowStatus: function() {
                            return flowStatus;
                        },
                        isSave: function() {
                            return isSave;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            }

            /**
             * [processRecord description] 获取微博流程记录
             * @param  {[object]} item [description] 微博对象
             * @param  {[object]} success [description] 成功后的回调
             * @return {[type]}      [description]
             */
            function processRecord(item, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weibo/service/processRecord/processRecord_tpl.html',
                    windowClass: 'process-record-weibo',
                    backdrop: false,
                    controller: 'weiboProcessRecordCtrl',
                    resolve: {
                        item: function() {
                            return item;
                        },
                    },
                });
                modalInstance.result.then(function() {
                    success();
                });
            }

            /**
             * [withdrawWeibo description] 微博撤稿-撤稿原因填写弹窗
             * @param  {[Object]} itemArr    [description] 设置的微博对象数组
             * @param  {[Function]} success [description] 成功后的回调函数
             * @return {[type]}         [description]
             */
            function withdrawWeibo(itemArr, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weibo/service/withdraw/weiboWithdraw_tpl.html',
                    windowClass: 'withdraw-weibo',
                    backdrop: false,
                    controller: 'weiboWithdrawCtrl',
                    resolve: {
                        itemArr: function() {
                            return itemArr;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            }

            /**
             * [withdrawWeibo description] 微博转发
             * @param  {[Object]} item    [description] 设置的微博对象
             * @param  {[String]} channelModule    [description] 模块
             * @param  {[Function]} success [description] 成功后的回调函数
             * @return {[type]}         [description]
             */
            function repostWeibo(item, channelModule, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weibo/service/repostWeibo/repostWeibo_tpl.html',
                    windowClass: 'repost-weibo',
                    backdrop: false,
                    controller: 'weiboRepostCtrl',
                    resolve: {
                        item: function() {
                            return item;
                        },
                        channelModule: function() {
                            return channelModule;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            }

            /**
             * [isLock description] 判断该微博是否上锁
             * @param  {[string]} weiboid [description] 微博id
             * @return {Boolean}          [description]
             */
            function isLock(weiboid) {
                var deferred = $q.defer();
                let params = angular.extend({}, weiboApiParams.isLockParams, {
                    ObjectId: weiboid,
                });
                weiboApiService.isLock(params).then(function(data){
                    deferred.resolve(data);
                });
                return deferred.promise;
            }

            /**
             * [lockWeibo description] 微博上锁
             * @param  {[string]} weiboid  [description] 设置的微博对象
             * @return  {[promise]}        [return description] promise
             */
            function lockWeibo(weiboid) {
                var deferred = $q.defer();
                let params = angular.extend({}, weiboApiParams.lockParams, {
                    ObjectId: weiboid,
                });
                weiboApiService.lock(params).then(
                    function(data) {
                        localStorageService.set('weiboLockDraft', JSON.stringify({ ObjectId: weiboid }));
                        deferred.resolve(data);
                    },
                    function(data) {
                        deferred.reject(data);
                    }
                );
                return deferred.promise;
            }

            /**
             * [unlockWeibo 微博解锁]
             * @param  {[string]} weiboid  [description] 微博id
             * @return  {[type]}  [return description]
             */
            function unlockWeibo(weiboid) {
                var deferred = $q.defer();
                let params = angular.extend({}, weiboApiParams.unLockParams, {
                    ObjectId: weiboid,
                });
                weiboApiService.unLock(params).then(
                    function(data) {
                        localStorageService.remove('weiboLockDraft');
                        deferred.resolve(data);
                    },
                    function(data) {
                        deferred.reject(data);
                    }
                );
                return deferred.promise;
            }

            /**
             * [forceUnlockWeibo description] 强制解锁微博
             * @param  {[type]} weiboid [description]
             * @return {[type]}         [description]
             */
            function forceUnlockWeibo(weiboid) {
                var deferred = $q.defer();
                let params = angular.extend({}, weiboApiParams.unLockParams, {
                    ObjectId: weiboid,
                });
                weiboApiService.forceUnLock(params).then(
                    function(data) {
                        deferred.resolve(data);
                    },
                    function(data) {
                        deferred.reject(data);
                    }
                );
                return deferred.promise;
            }

            /**
             * [hasSensitiveWords description] 判断数组中含有敏感词的微博稿件
             * @param  {[type]}  array [description] 微博稿件数组
             * @return {Boolean}       [description]
             */
            function hasSensitiveWords(array) {
                var defer = $q.defer();
                var sensitiveArr = [];
                array.forEach(function(item, index) {
                    if (item.ISCONTAINSENSITIVEWORDS == '1') {
                        sensitiveArr.push(item);
                    }
                });
                defer.resolve(sensitiveArr);
                return defer.promise;
            }

            /**
             * [initWeiboData description] 初始化微博数据
             * @return {[type]} [description]
             */
            function initWeiboData() {
                return {
                    CONTENT: '',
                    FUSIONSCMID: '0',
                    PICTURE: '',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    DOCGENRE: '',
                    ISNOPAYMENT: '1',
                    Video: '',
                    VideoTitle: '',
                    ISVIDEO: '0',
                };
            }

            /**
             * [uploadVideo 媒资选择器上传视频]
             *
             * @param   {[type]}  options  [options description]
             * @param   {[type]}  success  [success description]
             *
             * @return  {[type]}           [return description]
             */
            function uploadVideo(options, success) {
                let wbOptions = {
                    isMulti: false,
                    resourceType: '2',
                    isResolve: false,
                    success: success,
                    otherOptions: options,
                    isWeibo: true,
                };
                editingCenterService.mediaSelector(wbOptions);
            }

            /**
             * [uploadPicBak 媒资选择器上传图片]
             *
             * @param   {[type]}  options  [options description]
             * @param   {[type]}  success  [success description]
             *
             * @return  {[type]}           [return description]
             */
            function uploadPic(options, success) {
                let wbOptions = {
                    isMulti: true,
                    resourceType: '0',
                    maxSize: 9,
                    isResolve: false,
                    success: success,
                    otherOptions: options,
                    isWeibo: true,
                };
                editingCenterService.mediaSelector(wbOptions);
            }

            /**
            * [trail 送审]
            *
            * @param   {[type]}  params  [params 参数列表]
            *
            * @return  {[type]}          [return description]
            */
            function trail(params) {
                let defer = $q.defer();
                let initParams = weiboApiParams.trailParams;
                let requestParams = angular.extend({}, initParams, params);
                weiboApiService.trail(requestParams).then(function(data) {
                    defer.resolve(data);
                }, function(data){
                    defer.reject(data);
                });
                return defer.promise;
            }

            /**
             * [addAddress 添加地点]
             *
             * @param   {[type]}  options  [options description]
             * @param   {[type]}  success  [success description]
             *
             * @return  {[type]}           [return description]
             */
            function addAddress(options, success){
                editingCenterService.baiduMap(options).then(function(result){
                    success(result);
                });
            }
        },
    ]);
